module.exports = __webpack_public_path__ + "static/media/kids_52.5c19b6fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_52.jpg
// module id = 5908
// module chunks = 0